import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bar: {
      height: 16,
      borderRadius: '100px',
      position: 'relative',
      width: '100%',
      margin: '5px',
      backgroundColor: colors.grey,
    },
  })
)

export default useStyles
